import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.css'],
    standalone: false
})
export class AboutUsComponent implements OnInit {
  isMobileView = false;
  subscription: Subscription;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
  }

}
